import React from 'react';
import { FormattedMessage } from 'react-intl';

import { ButtonBox } from '../molecules/button-box';
import { trpc } from '../api/trpc';
import { ParentPaper } from '../atoms/parent-paper';
import { InputBox } from '../molecules/input-box';
import { useSelector } from '../store/utils';
import { useConfirm } from 'material-ui-confirm';

export const ReportTest = () => {
  const generateReport = trpc.reports.generate.useMutation();

  const confirm = useConfirm();

  const month = useSelector(
    // eslint-disable-next-line
    // @ts-ignore
    ({ variables: { REPORT_TEST_MONTH } }) => REPORT_TEST_MONTH || ''
  );

  const handleClick = async () => {
    try {
      const result = await generateReport.mutateAsync({ month });

      confirm({
        title: (
          <FormattedMessage
            id="report_test.generated"
            defaultMessage="Report vygenerován"
          />
        ),
        description: (
          <pre style={{ whiteSpace: 'pre-wrap', wordBreak: 'break-all' }}>
            {JSON.stringify(result, null, 2)}
          </pre>
        ),
        confirmationText: (
          <FormattedMessage id="report_test.ok" defaultMessage="OK" />
        ),
        hideCancelButton: true,
      });
    } catch (e) {
      alert('Chyba při generování reportu');
      return;
    }
  };

  return (
    <ParentPaper>
      <InputBox
        title={
          <FormattedMessage
            id="report_test.date"
            defaultMessage="Měsíc (např. 2025-09)"
          />
        }
        inputVariableId="REPORT_TEST_MONTH"
        label={
          <FormattedMessage
            id="report_test.date"
            defaultMessage="Měsíc (např. 2025-09)"
          />
        }
        fullWidth
      />
      <ButtonBox
        title={<FormattedMessage id="report_test.test" defaultMessage="Test" />}
        buttonLabel={
          <FormattedMessage id="report_test.button" defaultMessage="Test" />
        }
        onClick={handleClick}
        fullWidth
      />
    </ParentPaper>
  );
};
